import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { textWithEllipsisStyle } from 'utilities';

export const EDIT_BUTTON_CLASSNAME = 'editButton';

const StyledTitle = styled(Typography)(({ theme }) => ({
  ...textWithEllipsisStyle,
  fontWeight: 700,
  paddingRight: theme.spacing(1.5),

  [`& .${EDIT_BUTTON_CLASSNAME}`]: {
    marginLeft: theme.spacing(1.2),
    opacity: 0,
    transition: 'ease opacity 0.3s',
  },

  [`&:hover .${EDIT_BUTTON_CLASSNAME}`]: {
    opacity: 1,
  },
}));

export { StyledTitle };

// import { createStyles, makeStyles } from '@mui/styles';
// import { ITheme } from 'theme/types';
// import { textWithEllipsisStyle } from 'utilities';

// export const EDIT_BUTTON_CLASSNAME = 'editButton';

// const useStyles = makeStyles((theme: ITheme) => ({
//   title: {
//     ...textWithEllipsisStyle,
//     fontWeight: 700,
//     paddingRight: theme.spacing(1.5),

//     [`& .${EDIT_BUTTON_CLASSNAME}`]: {
//       marginLeft: theme.spacing(1.2),
//       opacity: 0,
//       transition: 'ease opacity 0.3s',
//     },

//     [`&:hover .${EDIT_BUTTON_CLASSNAME}`]: {
//       opacity: 1,
//     },
//   },
// }));

// export default useStyles;
